import type { Immutable } from "immer";
import React from "react";

import { StarRatingContainer, StarRatingStars } from "../StarRating";

import styles from "./index.module.scss";

export const ComparePageRating = (
    props: Immutable<{ rating: string; numReviews: number }>,
): React.JSX.Element => (
    <StarRatingContainer inverted className={styles.container}>
        <div className={styles.innerContainer}>
            <StarRatingStars
                rating={props.rating}
                className={styles.rating}
                overlayClassName={styles.overlay}
            />
            <div className={styles.text}>
                ( {props.rating} OUT OF 5 ) {props.numReviews} REVIEWS
            </div>
        </div>
    </StarRatingContainer>
);
